// src/layout/customer/CustomerDetails/calculateCustomerProfileCompletion.js

// Defines which fields are considered for profile completion.
// Add or remove fields here as requirements change.
const CUSTOMER_PROFILE_FIELDS_FOR_COMPLETION = [
    "name",
    "email", // Usually pre-filled and verified, but good to check
    "contact_number", // Changed from phone_number to match API field for primary contact
    "address_line1",
    "district",
    "taluk",
    "postcode",
    "state",
    // Optional fields you might want to add later for completion:
    // "address_line2",
    // "village",
    // "whatsapp_number",
    // "age",
    // "gender",
];

// Helper function to check if a field has a meaningful value
function hasValue(value) {
    if (value === undefined || value === null) {
        return false;
    }
    if (typeof value === "string") {
        return value.trim() !== "";
    }
    if (typeof value === "number") {
        return true; // Any number is considered filled
    }
    if (typeof value === "boolean") {
        return true; // Any boolean is considered filled
    }
    return false;
}

function calculateCustomerProfileCompletion(profile) {
    if (!profile) {
        return 0;
    }

    let filledFieldsCount = 0;
    const totalFields = CUSTOMER_PROFILE_FIELDS_FOR_COMPLETION.length;

    CUSTOMER_PROFILE_FIELDS_FOR_COMPLETION.forEach((fieldKey) => {
        if (hasValue(profile[fieldKey])) {
            filledFieldsCount++;
        }
    });

    if (totalFields === 0) {
        return 100; // Or 0, depending on how you want to handle an empty field list
    }

    const completionPercentage = (filledFieldsCount / totalFields) * 100;
    return Math.round(completionPercentage);
}

export default calculateCustomerProfileCompletion;